module.exports = __webpack_public_path__ + "img/Dantam Makeover 21.9de29ee8.jpg";